import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import { EffectsContainer } from 'mixins/withEffects';
import WCCFancyboxBaseVM, { WCCFancyboxBaseVMConfig, WCCFancyboxBaseVMConfigRaw } from './base';
import './iframe.html';

export interface WCCFancyboxIframeVMConfig extends WCCFancyboxBaseVMConfigRaw {
    src: SubscribableOrNullableValue<string>
    caption?: SubscribableOrNullableValue<string>
}

@injectable()
export default class WCCFancyboxIframeVM extends WCCFancyboxBaseVM<WCCFancyboxIframeVMConfig> {
    constructor(
        @inject(wccModules.componentConfig) config: WCCFancyboxIframeVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(config, info, effects);
    }

    protected override buildConfig(rawConfig: WCCFancyboxIframeVMConfig) {
        const oSrc = ko.flattenComputed(rawConfig.src);
        const oCaption = ko.flattenComputed(rawConfig.caption);

        return _({}).extend(super.buildConfig(rawConfig), <WCCFancyboxBaseVMConfig>{
            data: ko.pureComputed(() => ({
                src: oSrc(),
                type: 'iframe',
                opts: { 
                    caption: oCaption()
                }
            }))
        });
    }

    protected override buildOptions(rawConfig: WCCFancyboxIframeVMConfig) {
        return <FancyBoxOptions>_(super.buildOptions(rawConfig)).omit('src', 'caption');
    }
}